export default (function() {
    $('#mobile-menu .mobile-menu-main .menu-item-has-children').append('<div class="open-btn"></div>');
    $('#menu-go-back').click(function() {
      let subMenu = document.getElementById('mobile-menu');
      let target = deepest(subMenu, '.active');
      $(target).removeClass('active');
      let level = deepest(subMenu, '.active');
      if(subMenu == level) {
        $('#menu-go-back').removeClass('show');
      }
    });
    $('#mobile-menu .mobile-menu-main .menu-item-has-children').click(function(){
      $('#menu-go-back').addClass('show');
      $(this).find('.sub-menu:first').addClass('active');
    });
})();

function deepest (subMenu, select) {
  return [].slice.call (subMenu.querySelectorAll (select)).reduce (
    function (deepest, el) {
      for (var d = 0, e = el; e !== subMenu; d++, e = e.parentNode);
      return d > deepest.d ? {d: d, el: el} : deepest;
    }, {d: 0, el: subMenu}).el;
 };
